export default __webpack_public_path__ + "static/madonna-headshot-a5e93fc2be3c62701636428718aa470d.jpg";